/**
 * Minimal entry for Devise (sign in, sign up, password reset): Turbo + confirm + cookie consent + analytics.
 * Avoids loading the full Stimulus manifest and heavy app controllers.
 */
import "@hotwired/turbo-rails"
import "./lib/turbo_confirm"
import { application } from "./controllers/application"
import CookieConsentController from "./controllers/cookie_consent_controller"

application.register("cookie-consent", CookieConsentController)

import { initAnalytics } from "./lib/analytics"
initAnalytics()
